import { render, staticRenderFns } from "./ProPatientsCTherapyPage.vue?vue&type=template&id=0ee872e6"
import script from "./ProPatientsCTherapyPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsCTherapyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports